type ProfileLike = {
  role?: unknown;
  email?: string | null;
  email_verified_at?: string | null;
  account_source?: string | null;
  onboard_data?: {
    profile?: {
      role?: unknown;
    };
  } | null;
} | null | undefined;

const FAKE_EMAIL_DOMAIN = 'fakemail.pengi.ai';

export type CanonicalProfileRole = 'student' | 'parent_v2' | 'teacher';

export function getNormalizedProfileRole(profile: ProfileLike): string {
  const onboardRole = String(profile?.onboard_data?.profile?.role || '').toLowerCase();
  if (onboardRole) {
    return onboardRole;
  }

  return String(profile?.role || '').toLowerCase();
}

export function getCanonicalProfileRole(profile: ProfileLike): CanonicalProfileRole {
  const normalizedRole = getNormalizedProfileRole(profile);
  if (normalizedRole === 'parent_v2') {
    return 'parent_v2';
  }
  if (normalizedRole === 'teacher') {
    return 'teacher';
  }
  return 'student';
}

export function isParentRole(role: string): boolean {
  return role === 'parent_v2';
}

export function isParentProfile(profile: ProfileLike): boolean {
  return getCanonicalProfileRole(profile) === 'parent_v2';
}

export function isTeacherRole(role: string): boolean {
  return role === 'teacher';
}

export function isTeacherProfile(profile: ProfileLike): boolean {
  return getCanonicalProfileRole(profile) === 'teacher';
}

export function isStudentRole(role: string): boolean {
  return role === 'student';
}

export function isStudentProfile(profile: ProfileLike): boolean {
  return getCanonicalProfileRole(profile) === 'student';
}

export function isEmailVerified(profile: ProfileLike): boolean {
  if (profile?.email_verified_at) return true;
  // Parent-created students with fake emails can't verify — treat as verified
  if (profile?.email?.endsWith(`@${FAKE_EMAIL_DOMAIN}`)) return true;
  if (profile?.account_source === 'parent_created') return true;
  return false;
}
